var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-box"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"intro-box"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/long-logo.png"),"alt":"PermitBook logo"}}),_vm._t("default")],2)]),_c('CustomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }